import { render } from "./ModalViewRRIM.vue?vue&type=template&id=53c3c6fc&scoped=true"
import script from "./ModalViewRRIM.vue?vue&type=script&lang=js"
export * from "./ModalViewRRIM.vue?vue&type=script&lang=js"

import "./ModalViewRRIM.vue?vue&type=style&index=0&id=53c3c6fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c3c6fc"]])

export default __exports__